import React from 'react'

export enum TabsSelectorUI5Type {
    DEFAULT     = 'default',
    BORDERED    = 'bordered',
    BUTTONS     = 'buttons'
}

type Props = {
    className?  : string

    type        : TabsSelectorUI5Type
    options     : Option[],
    selectedId  : ID

    disabled?   : boolean

    onChange    : func
}

export default function TabsSelectorUI5(props: Props) {

    const onClick = (value: ID) => {
        if (props.disabled) return
        props.onChange && props.onChange(value)
    }

    const classes = Classes("ui5-tabs-selector", props.className, {
        'default-type'  : props.type === TabsSelectorUI5Type.DEFAULT,
        'bordered-type' : props.type === TabsSelectorUI5Type.BORDERED,
        'buttons-type'  : props.type === TabsSelectorUI5Type.BUTTONS
    })

    return (
        <div className={classes}>
            {_.map(props.options, option=> {
                const tabClasses = Classes("tab-option", {
                    selected: option.value === props.selectedId
                })

                const iconClasses = Classes("tab-option-icon", option.icon, {
                    "m-r-5": !!option.label
                })

                return (
                    <div key        = {option.value}
                         className  = {tabClasses}
                         onClick    = {()=>onClick(option.value)}>
                        <div className={iconClasses}/>
                        {option.label && <div className="tab-option-label">{option.label}</div>}
                    </div>
                )
            })}
        </div>
    )
}

TabsSelectorUI5.defaultProps = {
    type: TabsSelectorUI5Type.DEFAULT
}